var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-row",
        [
          _c("b-col", { staticClass: "my-1", attrs: { cols: "12" } }, [
            _c(
              "div",
              { staticClass: "d-flex align-items-center justify-content-end" },
              [
                _vm.HasPermission(_vm.PermissionList.Sales_Create)
                  ? _c(
                      "b-button",
                      { attrs: { variant: "primary", to: "/leads/leads-add" } },
                      [
                        _c("span", { staticClass: "text-nowrap" }, [
                          _vm._v("Add Lead"),
                        ]),
                      ]
                    )
                  : _vm._e(),
              ],
              1
            ),
          ]),
        ],
        1
      ),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { staticClass: "my-1", attrs: { cols: "12", md: "6" } },
            [
              _c(
                "b-form-group",
                { staticClass: "mb-0", attrs: { label: "Select Columns:" } },
                [
                  _c("b-form-checkbox-group", {
                    attrs: { options: _vm.columnOptions },
                    model: {
                      value: _vm.selectedColumns,
                      callback: function ($$v) {
                        _vm.selectedColumns = $$v
                      },
                      expression: "selectedColumns",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "b-col",
        { staticClass: "my-1", attrs: { cols: "12", sm: "2" } },
        [
          _c(
            "b-form-group",
            { staticClass: "mb-0" },
            [
              _c(
                "label",
                { staticClass: "d-inline-block text-sm-left mr-50" },
                [_vm._v("Per page")]
              ),
              _c("b-form-select", {
                attrs: {
                  id: "perPageSelect",
                  size: "sm",
                  options: _vm.pageOptions,
                },
                model: {
                  value: _vm.perPage,
                  callback: function ($$v) {
                    _vm.perPage = $$v
                  },
                  expression: "perPage",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("b-col", { staticClass: "my-1", attrs: { cols: "12" } }, [
        _c(
          "div",
          { staticClass: "d-flex align-items-center justify-content-end" },
          [
            _vm.HasPermission(_vm.PermissionList.Sales_Search)
              ? _c(
                  "b-button",
                  {
                    attrs: { variant: "outline-danger" },
                    on: { click: _vm.clearFilters },
                  },
                  [_vm._v(" Clear Filters ")]
                )
              : _vm._e(),
          ],
          1
        ),
      ]),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { cols: "12" } },
            [
              _c("b-table", {
                attrs: {
                  striped: "",
                  hover: "",
                  responsive: "",
                  "per-page": _vm.perPage,
                  "current-page": _vm.currentPage,
                  items: _vm.filteredLeads,
                  fields: _vm.dynamicFields,
                  "sort-by": _vm.sortBy,
                  "sort-desc": _vm.sortDesc,
                  "sort-direction": _vm.sortDirection,
                },
                on: {
                  "update:sortBy": function ($event) {
                    _vm.sortBy = $event
                  },
                  "update:sort-by": function ($event) {
                    _vm.sortBy = $event
                  },
                  "update:sortDesc": function ($event) {
                    _vm.sortDesc = $event
                  },
                  "update:sort-desc": function ($event) {
                    _vm.sortDesc = $event
                  },
                  filtered: _vm.onFiltered,
                },
                scopedSlots: _vm._u([
                  {
                    key: "head(id)",
                    fn: function () {
                      return [
                        _c(
                          "div",
                          { staticClass: "d-flex flex-column" },
                          [
                            _c("span", [_vm._v("Lead Name")]),
                            _c("b-form-input", {
                              attrs: {
                                placeholder: "Filter by Lead Name",
                                size: "sm",
                              },
                              on: { input: _vm.filterTable },
                              model: {
                                value: _vm.filters.leadName,
                                callback: function ($$v) {
                                  _vm.$set(_vm.filters, "leadName", $$v)
                                },
                                expression: "filters.leadName",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                    proxy: true,
                  },
                  {
                    key: "head(typeDesc)",
                    fn: function () {
                      return [
                        _c(
                          "div",
                          { staticClass: "d-flex flex-column" },
                          [
                            _c("span", [_vm._v("Lead Type")]),
                            _c("b-form-select", {
                              attrs: {
                                options: _vm.leadTypeOptions,
                                size: "sm",
                              },
                              on: { change: _vm.filterTable },
                              model: {
                                value: _vm.filters.leadType,
                                callback: function ($$v) {
                                  _vm.$set(_vm.filters, "leadType", $$v)
                                },
                                expression: "filters.leadType",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                    proxy: true,
                  },
                  {
                    key: "head(email)",
                    fn: function () {
                      return [
                        _c(
                          "div",
                          { staticClass: "d-flex flex-column" },
                          [
                            _c("span", [_vm._v("Email")]),
                            _c("b-form-input", {
                              attrs: {
                                placeholder: "Filter by Email",
                                size: "sm",
                              },
                              on: { input: _vm.filterTable },
                              model: {
                                value: _vm.filters.email,
                                callback: function ($$v) {
                                  _vm.$set(_vm.filters, "email", $$v)
                                },
                                expression: "filters.email",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                    proxy: true,
                  },
                  {
                    key: "head(salesPersonId)",
                    fn: function () {
                      return [
                        _c(
                          "div",
                          { staticClass: "d-flex flex-column" },
                          [
                            _c("span", [_vm._v("Sales Person")]),
                            _c("b-form-input", {
                              attrs: {
                                placeholder: "Filter by Sales Person",
                                size: "sm",
                              },
                              on: { input: _vm.filterTable },
                              model: {
                                value: _vm.filters.salesPerson,
                                callback: function ($$v) {
                                  _vm.$set(_vm.filters, "salesPerson", $$v)
                                },
                                expression: "filters.salesPerson",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                    proxy: true,
                  },
                  {
                    key: "head(stage)",
                    fn: function () {
                      return [
                        _c(
                          "div",
                          { staticClass: "d-flex flex-column" },
                          [
                            _c("span", [_vm._v("Status")]),
                            _c("b-form-input", {
                              attrs: {
                                placeholder: "Filter by Status",
                                size: "sm",
                              },
                              on: { input: _vm.filterTable },
                              model: {
                                value: _vm.filters.status,
                                callback: function ($$v) {
                                  _vm.$set(_vm.filters, "status", $$v)
                                },
                                expression: "filters.status",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                    proxy: true,
                  },
                  {
                    key: "head(createdOn)",
                    fn: function () {
                      return [
                        _c(
                          "div",
                          { staticClass: "d-flex flex-column" },
                          [
                            _c("span", [_vm._v("Created On")]),
                            _c("DatePicker", {
                              staticClass: "small-datepicker",
                              attrs: {
                                range: "",
                                placeholder: "Filter by Date Range",
                                size: "sm",
                                clearable: false,
                                "input-attr": { readonly: true },
                              },
                              on: {
                                change: _vm.filterTable,
                                focus: _vm.openCalendar,
                              },
                              model: {
                                value: _vm.filters.createdOnRange,
                                callback: function ($$v) {
                                  _vm.$set(_vm.filters, "createdOnRange", $$v)
                                },
                                expression: "filters.createdOnRange",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                    proxy: true,
                  },
                  {
                    key: "cell(status)",
                    fn: function (data) {
                      return [
                        data.item.status === 2 && data.item.isClient
                          ? _c("b-badge", { attrs: { variant: "primary" } }, [
                              _vm._v(" Won "),
                            ])
                          : data.item.status === 3 && data.item.isClient
                          ? _c("b-badge", { attrs: { variant: "primary" } }, [
                              _vm._v(" Direct Customer "),
                            ])
                          : data.item.status === 0
                          ? _c("b-badge", { attrs: { variant: "info" } }, [
                              _vm._v(" New "),
                            ])
                          : data.item.status === 1
                          ? _c("b-badge", { attrs: { variant: "Warning" } }, [
                              _vm._v(" Discussion "),
                            ])
                          : _vm._e(),
                      ]
                    },
                  },
                  {
                    key: "cell(salesPersonId)",
                    fn: function (data) {
                      return [
                        data.item.salesPersonId === null
                          ? _c("p", [_vm._v("-")])
                          : _c("p", [
                              _vm._v(
                                _vm._s(
                                  _vm.getSalePersonName(data.item.salesPersonId)
                                )
                              ),
                            ]),
                      ]
                    },
                  },
                  {
                    key: "cell(id)",
                    fn: function (data) {
                      return [
                        data.item.id === null
                          ? _c("p", [_vm._v("-")])
                          : _c("p", [
                              _vm._v(_vm._s(_vm.getLeadFullName(data.item.id))),
                            ]),
                      ]
                    },
                  },
                  {
                    key: "cell(stage)",
                    fn: function (data) {
                      return [
                        data.item.stage
                          ? _c("p", [
                              _vm._v(" " + _vm._s(data.item.stage) + " "),
                            ])
                          : _c("p", [_vm._v(" - ")]),
                      ]
                    },
                  },
                  {
                    key: "cell(createdOn)",
                    fn: function (data) {
                      return [
                        _vm._v(
                          " " +
                            _vm._s(_vm.formatDate(data.item.createdOn)) +
                            " "
                        ),
                      ]
                    },
                  },
                  {
                    key: "cell(actions)",
                    fn: function (data) {
                      return [
                        data.item.isClient
                          ? _c(
                              "b-button",
                              {
                                attrs: {
                                  variant: "primary",
                                  to: _vm.returnToCustomer(data.item.id),
                                },
                              },
                              [
                                _c("feather-icon", {
                                  staticClass: "mr-50",
                                  attrs: { icon: "Edit2Icon" },
                                }),
                                _c("span", [_vm._v("View")]),
                              ],
                              1
                            )
                          : _c(
                              "b-button",
                              {
                                attrs: {
                                  to: _vm.getLeadEditData(data.item.id),
                                  variant: "primary",
                                },
                              },
                              [
                                _c("feather-icon", {
                                  staticClass: "mr-50",
                                  attrs: { icon: "Edit2Icon" },
                                }),
                                _vm._v(" "),
                                _c("span", [_vm._v("View")]),
                              ],
                              1
                            ),
                      ]
                    },
                  },
                ]),
              }),
              _c(
                "div",
                { staticClass: "d-flex justify-content-center mb-1" },
                [
                  _vm.loading
                    ? _c("b-spinner", {
                        staticStyle: { width: "3rem", height: "3rem" },
                        attrs: {
                          variant: "success",
                          label: "Spinning",
                          block: "",
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "b-col",
            { attrs: { cols: "12" } },
            [
              _c("b-pagination", {
                staticClass: "my-0",
                attrs: {
                  "total-rows": _vm.totalRows,
                  "per-page": _vm.perPage,
                  align: "center",
                  size: "sm",
                },
                model: {
                  value: _vm.currentPage,
                  callback: function ($$v) {
                    _vm.currentPage = $$v
                  },
                  expression: "currentPage",
                },
              }),
              _c("b-form-group", [
                _vm._v(
                  " Showing " +
                    _vm._s(
                      _vm.totalRows > 0
                        ? _vm.perPage * (_vm.currentPage - 1) + 1
                        : 0
                    ) +
                    " to " +
                    _vm._s(
                      _vm.totalRows > 0
                        ? Math.min(_vm.perPage * _vm.currentPage, _vm.totalRows)
                        : 0
                    ) +
                    " of " +
                    _vm._s(_vm.totalRows > 0 ? _vm.totalRows : 0) +
                    " entries "
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }